module.exports = __webpack_public_path__ + "img/star-sharp-half-stroke.28ad51d6.svg";